module.exports = __webpack_public_path__ + "img/bank3-bg.d5666bbf.png";